<template>
  <section class="maps-section">
    <div class="container">
      <div class="about-content">
        <h2 class="section-title">Lokasi</h2>
        <v-row>
          <v-col cols="12">
            <v-card elevation="3" class="map-card">
              <v-card-title class="map-header">
                <v-icon large color="primary" class="mr-2"
                  >mdi-map-marker</v-icon
                >
                PT BATHI DUA PUTRA
              </v-card-title>
              <v-card-text>
                <IframeComponent :url="iframeUrl" class="map-frame" />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
    <div>
      <a :href="whatsappLink" class="whatsapp-button">
        <i class="fab fa-whatsapp"></i> Hubungi Kami di WhatsApp
      </a>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import IframeComponent from "../components/IframeComponent.vue";

export default {
  name: "LokasiView",
  components: {
    IframeComponent,
  },
  data() {
    return {
      iframeUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d991.4380989178982!2d106.96924299817782!3d-6.296234400000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69927837ebb651%3A0x2a242cfe4cc86169!2sJl.%20Pondok%20Gede%20Permai%20No.12D%2C%20RT.003%2FRW.007%2C%20Jatirasa%2C%20Kec.%20Jatiasih%2C%20Kota%20Bks%2C%20Jawa%20Barat%2017424!5e0!3m2!1sid!2sid!4v1758358210437!5m2!1sid!2sid",
      whatsappLink:
        "https://api.whatsapp.com/send?phone=6289654367407&text=*Hai%20Admin%20Saya%20mau%20tanya%20tentang%20pengiriman%20barang%20nih%2C%20Saya%20dapat%20wa%20nya%20dari%20Web%20nya%20bdpcargo.co.id%20Terima%20kasih*",
    };
  },
  methods: {},
};
</script>


<style lang="scss" scoped>
// Add these styles to your existing <style> section
.about-section {
  padding: 80px 0;
  background-color: #fff;
}

.section-title {
  text-align: center;
  font-size: 36px;
  color: #333;
  margin-bottom: 40px;
}

.about-subtitle {
  font-size: 24px;
  color: #2c5282;
  margin-bottom: 20px;
}

.about-text {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 20px;
  color: #4a5568;
}

.highlight {
  color: #2c5282;
  font-weight: 600;
}

.vm-title {
  font-size: 24px;
  color: #2c5282;
  margin-bottom: 15px;
}

.vm-text {
  font-size: 16px;
  line-height: 1.6;
  color: #4a5568;
}

.mission-list {
  list-style-type: none;
  padding: 0;

  li {
    font-size: 16px;
    line-height: 1.6;
    color: #4a5568;
    margin-bottom: 15px;
    padding-left: 20px;
    position: relative;

    &:before {
      content: "•";
      color: #2c5282;
      position: absolute;
      left: 0;
    }
  }
}

.vision-section {
  margin-bottom: 30px;
}

.about-card,
.vision-mission-card {
  height: 100%;
  padding: 20px;
}
.download-btn {
  width: 100%;
  padding: 20px !important;
  font-size: 16px !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
  border-radius: 8px !important;
  background: linear-gradient(45deg, #2c5282, #3182ce) !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(44, 82, 130, 0.3) !important;
  }

  .v-icon {
    margin-right: 8px;
  }
}
.whatsapp-button {
  background-color: #25d366; /* Warna latar belakang WhatsApp */
  color: #fff; /* Warna teks */
  display: inline-block;
  padding: 10px 20px;
  border-radius: 30px; /* Untuk membuat tombol berbentuk bulat */
  text-decoration: none;
  position: fixed;
  bottom: 20px;
  right: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); /* Efek bayangan */
}

.whatsapp-button i {
  margin-right: 10px; /* Jarak antara ikon dan teks */
}

// Add this to the existing <style> section
.maps-section {
  padding: 60px 0;
  background-color: #f5f5f5;
}

.maps-title {
  text-align: center;
  margin-bottom: 30px;
  font-size: 32px;
  color: #333;
}

.map-card {
  border-radius: 8px;
  overflow: hidden;
}

.map-header {
  background-color: #fff;
  padding: 16px;
  font-size: 20px;
  border-bottom: 1px solid #eee;
}

.map-frame {
  height: 450px;
  width: 100%;
  border: none;
}

// Update your IframeComponent style to be responsive
:deep(.iframe-container) {
  position: relative;
  padding-bottom: 56.25%; // 16:9 aspect ratio
  height: 0;
  overflow: hidden;
}

:deep(.iframe-container iframe) {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
